/**
 * 試用版配置
 * 管理試用版的功能限制和預設設定
 */

/**
 * 試用版可用的語音角色 ID 列表
 * 這些角色可以在試用版中使用
 */
export const TRIAL_VOICE_IDS = [
  8,   // 白石美穗（しらいし みほ）- 預設試用角色
] as const

export type TrialVoiceId = typeof TRIAL_VOICE_IDS[number]

/**
 * 試用版角色顯示名稱
 */
export const TRIAL_ROLE_DISPLAY_NAME = '白石美穗'

/**
 * 獲取試用版預設語音 ID
 */
export const getDefaultTrialVoiceId = (): number => {
  return TRIAL_VOICE_IDS[0] // 預設使用白石美穗 (voice_id: 8)
}

/**
 * 檢查語音 ID 是否可用於試用版
 */
export const isTrialVoiceId = (voiceId: number): boolean => {
  return TRIAL_VOICE_IDS.includes(voiceId as TrialVoiceId)
}

/**
 * 試用版功能限制
 */
export const TRIAL_LIMITATIONS = {
  // 試用版只能使用預設的語音角色
  voiceSelection: false,
  // 試用版不保存進度到數據庫（只使用 localStorage）
  saveProgress: false,
  // 試用版可以訪問的功能
  allowedFeatures: [
    'gojuon_learn',
    'gojuon_practice',
    'gojuon_write'
  ] as const
} as const

